// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const ImageExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.499756} width={36} height={36} rx={8} fill="#4789E6" />
				<g opacity={0.8}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10.6757 14.0368C10.6757 14.7664 10.0843 15.3579 9.35471 15.3579C8.62513 15.3579 8.03369 14.7664 8.03369 14.0368C8.03369 13.3073 8.62513 12.7158 9.35471 12.7158C10.0843 12.7158 10.6757 13.3073 10.6757 14.0368ZM15.5421 13.2571C15.7451 12.9865 16.151 12.9865 16.354 13.2571L21.858 20.5958C22.0314 20.7608 22.3036 20.7817 22.5017 20.6336C22.7229 20.4683 22.7682 20.155 22.6029 19.9338L21.4747 18.4244L23.459 15.8731C23.6622 15.6119 24.057 15.6119 24.2601 15.8731L28.7504 21.6462C29.2688 22.3129 28.7938 23.2842 27.9493 23.2842H17.6948L17.695 23.284H10.0517C9.21541 23.284 8.73804 22.3292 9.23982 21.6602L15.5421 13.2571Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
ImageExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default ImageExtension;
